export default "__VITE_ASSET__C4c9Plrz__"